import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  educationKeys,
  type CreateEducationRegistrationRequest,
} from '@platform/billing';
import { educationApi } from './education.api';

/**
 * 접수 생성. 무료 접수는 이 시점에 자리가 잡히므로 잔여석 캐시를 버린다 —
 * 그대로 두면 다른 탭의 회차 목록이 내가 방금 채운 자리를 계속 비어 있게 보여준다.
 */
export function useCreateEducationRegistration() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: CreateEducationRegistrationRequest) =>
      educationApi.createRegistration(body),
    // 접수 단계에 따라 안내 문구가 달라 useEducationCheckout에서 한 번만 처리한다.
    meta: { skipGlobalError: true },
    onSettled: () => {
      void qc.invalidateQueries({ queryKey: educationKeys.all });
    },
  });
}
